module.exports = __webpack_public_path__ + "media/content-creator/tech-3-8ad73fc3.png";